export default {
  // button: {
  //   confirm: 'Confirm',
  //   login: 'Login'
  // }
  created: "Create",
  chat: "Chat",
  home: "Store",
  paint: "Paint",
  template: "Template",
  square: "Square",
  MostPopular: "Popular",
  RecentlyReleased: "Recent",
  Author: "Author",
  LightApp: "Light",
  ApplicationOfKnowledge: "Knowledge",
  Agent: "Agent",
  WorkFlow: "WorkFlow",
  LoadMore: "Load More",
  Collection: "Collection",
  All: "All",
  PleaseEnterTheSearchContent: "Please enter the search content.",
  SignInSuccess:
    "Sign in successful, congratulations on earning {count} credits",
  SignIn: "Sign in",
  CheckSuccessful: "Check-in successful, congratulations on earning",
  Points: "credits.",
  Sure: "Sure",
  ContactUs: "Contact Us",
  salesEmailDes:
    "Please contact us ({email}) and describe your questions or requirements. We will respond within 48 hours.",
  YouHaveSignedInToday: "You have signed in today, please come back tomorrow!",
  ExitConfirmation:
    "Exiting will clear all chat records, do you confirm to exit?",
  LogOut: "Log Out",
  ConfirmExit: "Confirm Exit",
  Cancel: "Cancel",
  ExitSuccessful: "Exit Successful",
  CancelExit: "Cancel Exit",
  PleaseEnterTheInvitationCode: "Please enter the invitation code",
  SuccessfullyReceived: "Successfully Received",
  RightsClaim: "Rights Claim",
  Nickname: "Nickname ",
  Account: "Account",
  ClaimCode: "Claim Code ",
  Confirm: "Confirm",
  Help: "Help",
  Version: "Version",
  MyAccount: "Account",
  DailySignIn: "Check In",
  Documentation: "Documentation",
  OfficialWebsite: "Official Website",
  Login: "Continue",
  LogIn: "Login",
  PageNotFound: "Page Not Found",
  ViewDocumentation: "Document",
  BackToHome: "Back To Home",
  Management: "Management",
  PleaseEnterYourKey: "Please enter your Key",
  ClickToApply: "Click to apply for ",
  ApiKey: "API Key",
  SaveSuccessful: "Save successful",
  ShareApplication: "Share",
  ApplicationLink: "App Link ",
  CopyLink: "Copy Link",
  IntegrateSystem:
    "You can integrate the APP to the following platform, or to your system with OpenAPI.",
  OpenAPI: "Open API",
  WebEmbed: "Web Integration",
  WeChatOfficial: "WeChat Official",
  WeChatWork: "WeChat Work",
  WeChatService: "WeChat Service",
  QuickAccess: "Quick Integration",
  CopySuccessful: "Copy successful",
  WeChat: "WeChat",
  FeiShu: "Feishu",
  DingTalk: "DingTalk",
  Add: "Add",
  PleaseEnterContent: "Please enter content",
  AddAll: "Add All",
  PleaseEnterTriggerPrefix: "Please enter trigger prefix",
  SelectVariable: "Select reference variable",
  NoOptions: "No options",
  ThisVariableDoesNotExist: "This variable does not exist",
  RegisterSuccess: "Registration successful",
  BindPhoneSuccess: "Phone number bound successfully",
  ModifyPasswordSuccess: "Password modified successfully",
  BindOfficialAccountSuccess: "Official account bound successfully",
  LoginSuccess: "Login successful",
  PleaseEnterPhoneNumber: "Please enter email address",
  PleaseEnterPassword: "Enter your password",
  PleaseEnterNewPassword: "New password",
  PleaseEnterVerificationCode: "Please enter verification code",
  GetVerificationCode: "Get verification code",
  WeChatLogin: "WeChat Login",
  PhoneLogin: "Phone Login",
  Register: "Sign Up",
  Continue: "Continue",
  Password: "Password",
  VerificationCode: "Verification Code",
  PhoneNumber: "Phone Number",
  NoAccount: "No account?",
  RegisterNow: "Sign up now",
  ForgotPassword: "Forgot password",
  BindPhoneNumber: "Bind phone number",
  ModifyPassword: "Modify Password",
  Complete: "Complete",
  Skip: "Skip",
  ScanQRCodeToLogin: "Scan QR code to login",
  LongPressQRCodeToLogin: "Long press QR code to login",
  SwipeLeftAfterFollowing: "Swipe left after following",
  ScanQRCodeToFollowOfficialAccount:
    "Scan QR code to follow official account for quick login",
  AlreadyHaveAccount: "Already have an account?",
  LoginNow: "Login now",
  BindSuccess: "Binding successful",
  ScanSuccess: "Scan successful",
  Agree: "Agree",
  Disagree: "Disagree",
  UserAgreement: "User Agreement",
  PrivacyPolicy: "Privacy Policy.",
  ServiceAgreementAndPrivacy: "Service Agreement and Privacy Protection",
  HaveReadAndAgree: "I have read and agree to the following agreements ",
  WeChatLoginTip:
    'Users who have logged in via WeChat do not need to register again, you can bind your phone number in "My Account"',
  BindPhoneNumberTip:
    'Users who have logged in via WeChat scan code do not need to register again, you can bind your phone number in "My Account" page',
  InputPlaceholders: {
    phoneNumber: "Please enter email address",
    password: "Please enter password",
    newPassword: "Set your new password",
    verificationCode: "Enter code",
    verificationyCode: "Enter verification code",
    SetLoginPassword: "Set your password",
  },
  And: "and",
  Submit: "Continue",
  Bind: "Bind",
  ModifySuccess: "Password modified successfully",
  AlreadyHaveAccountSkip:
    "Already have an account or continue with google/github?",
  GetVerificationCodeText: "Get code",
  ScanQRCodeToFollowOfficialAccountTip:
    "Scan QR code to follow official account, you can also use it in the official account~",
  FromLocalStorage: {
    privacyPolicy: "privacyPolicy",
  },
  CongratulationsPasswordModified:
    "Congratulations, your password has been modified successfully",
  CongratulationsOfficialAccountBound:
    "Congratulations, official account bound successfully",
  LocalStorageKeys: {
    shareCode: "shareCode",
    source: "source",
    sourceDetail: "sourceDetail",
    shareId: "shareId",
  },
  CurrentVersion: "Current Version",
  ValidityPeriod: "Validity Period",
  ApplicationCount: "Application Count",
  WorkflowCount: "Workflow Count",
  KnowledgeBaseCapacity: "Knowledge Base Capacity",
  KnowledgeBaseEntries: "Knowledge Base Entries",
  DatabaseTotalRows: "Database Total Rows",
  CustomPluginCount: "Custom Plugin Count",
  ClientCount: "Client Count",
  TeamMemberCount: "Team Member Count",
  EnterpriseMemberCount: "Enterprise Member Count",
  UpgradeVersion: "Upgrade Version",
  Basic: "Free",
  Standard: "Pro",
  Professional: "Team",
  Enterprise: "Enterprise",
  Custom: "Custom",
  ExceededLimitTip: {
    app: "Application count exceeded limit. To avoid usage issues, please upgrade or clean up manually",
    workflow:
      "Workflow count exceeded limit. To avoid usage issues, please upgrade or clean up manually",
    knowledgeBase:
      "Knowledge base capacity exceeded limit. To avoid usage issues, please upgrade or clean up manually",
    knowledgeEntries:
      "Knowledge base entries exceeded limit. To avoid usage issues, please upgrade or clean up manually",
    database:
      "Database total rows exceeded limit. To avoid usage issues, please upgrade or clean up manually",
    customPlugin:
      "Custom plugin count exceeded limit. To avoid usage issues, please upgrade or clean up manually",
    client:
      "Current client capacity insufficient. To avoid usage issues, please upgrade",
    team: "Current {type} space capacity insufficient. To avoid usage issues, please upgrade",
  },
  Unit: {
    items: "items",
    persons: "persons",
    rows: "rows",
  },
  IKnow: "I know",
  Announcement: "Announcement",
  AnnouncementCenter: " ",
  MarkAllAsRead: "All read",
  NoNotifications: "No notifications",
  Back: "Back",
  ScrollMouseToZoom: "",
  PinchToZoom: "Pinch to zoom",
  ImageUploadOnlySupportFormat: "Image upload only supports jpeg, png format",
  ImageSizeLessThan5MB: "Image size must be less than 5MB!",
  NoPermission: "No permission",

  // 主菜单
  Create: "Create", // 创造
  Access: "Publish", // 接入
  Manage: "Manage", // 管理
  Discover: "Discover", // 发现

  // Create 子菜单
  Apps: "Agents", // 应用
  Knowledge: "Knowledge", // 知识库
  Database: "Databases", // 数据库
  Plugins: "Plugins", // 插件
  Workflow: "Workflows", // 工作流

  // Access 子菜单
  APIAccess: "Integrations", // 应用接入
  Client: "Clients", // 客户端
  Customers: "Customers", // 客户管理
  Chat: "Chat", // 对话管理

  // Manage 子菜单

  Dashboard: "Analysis", // 数据看板
  Team: "Team", // 团队空间

  // Discover 子菜单
  Templates: "Template", // 模板中心
  Store: "Store", // 应用广场

  // 版本标签

  Pro: "Pro", // 专业版
  EmailLogin: {
    email: "Email",
    pleaseEnterEmail: "Enter your email address",
  },

  TermsOfService: "Terms of Service",
  ByContinuing: "By continuing, you are agreeing to Link.AI",
  WelcomeLinkAi: "Welcome to Link.AI",
  AlreadyRememberedYourPassword: "Already remembered your password?",
  PleaseCompleteSecurityVerification: "Please complete security verification",
  VerificationSuccess: "Success",
  VerificationFailed: "Failed",
  SlideToCompleteVerification: "Slide right to the correct position",
  SearchAgent: "Search Agent",
  SearchTemplate: "Search Template",
  Search: "Search",
  Console: "Console",
  Docs: "Docs",
  Portal: "Portal",
  Notifications: "Notifications",
  CreateAgent: "Get started",
  LogLOut: "Log Out",
  CongratulationsOnGetting: "Congratulations on getting ",
  Credits: "credits",
  CheckIn: "Check In",
  YouHaveCheckedInTodayPleaseComeAgainTomorrow:
    "You have checked in today, please try again tomorrow!",
  LogOutAccount: "Log Out",
  AreYouSureYouWantToLogOut:
    "Log out will clear all chat records, are you sure to log out?",
  HoldToSpeak: "Hold to speak",
  Speaking: "Speaking",
  Thinking: "Thinking",
  ClickToCancelReply: "Click to cancel reply",
  NetworkErrorPleaseRetry: "Network error, please try again",
  PleaseAllowThePageToUseTheMicrophone:
    "Please allow the page to use the microphone",
  NoVoicePermission: "Current no voice permission",
  goToDocumentCenter: "Go to document center",
  goToUpgrade: "Go to upgrade",
  functionIntroduction: "Function Introduction",
};
